import { render, staticRenderFns } from "./uploadPopup.vue?vue&type=template&id=6a9ca71a&scoped=true&"
import script from "./uploadPopup.vue?vue&type=script&lang=js&"
export * from "./uploadPopup.vue?vue&type=script&lang=js&"
import style0 from "./uploadPopup.vue?vue&type=style&index=0&id=6a9ca71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ca71a",
  null
  
)

export default component.exports